import { createBrowserHistory } from 'history'

const _history = createBrowserHistory()
// eslint-disable-next-line
export default () => _history
